module.exports = __webpack_public_path__ + "static/media/monitor_app_zh.4804d6b7.png";